import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import styles from './content-shifter.scss';
export default class ContentShifter extends React.Component {
  getTransformValue() {
    const {
      active,
      width,
      itemWidth,
      inFrameItemsCount,
      reduceMarginsBy,
      isRTL
    } = this.props;
    const translateX = (width - inFrameItemsCount * itemWidth + reduceMarginsBy * 2) * (isRTL ? -1 : 1);
    return active ? "translate3d(" + translateX + "px, 0, 0)" : '';
  }
  render() {
    const {
      children,
      reduceMarginsBy
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "content-shifter",
      className: styles.container,
      style: {
        transform: this.getTransformValue(),
        margin: "0 " + -reduceMarginsBy + "px"
      }
    }, children);
  }
}
_defineProperty(ContentShifter, "defaultProps", {
  reduceMaringsBy: 0
});
//# sourceMappingURL=content-shifter.js.map